import { ExpeditionFilters, ExpeditionFiltersEncoded, Filter, QueryParams } from 'types';
import { addDaysToDate, formatDateAsQueryParam } from './date';

export function formatExpeditionQueryAsFilter(query: ExpeditionFiltersEncoded): ExpeditionFilters {
  const filter: ExpeditionFilters = {
    startDate: query.startDate ? new Date(query.startDate) : null,
    endDate: query.endDate ? new Date(query.endDate) : null,
    material: query.material,
    buyer: query.buyer,
    invalidOnly: query.invalidOnly,
  };

  if (undefined !== query.isMiseEnCoherenceAccepted) {
    filter.isMiseEnCoherenceAccepted = query.isMiseEnCoherenceAccepted;
  }

  return filter;
}

export function formatFilterAsQueryParams(
  filters: Filter | null | undefined,
  dateAttribute: string,
  strictBefore: boolean = true,
): QueryParams {
  if (!filters) return {};
  let params: QueryParams = {};
  if (filters?.startDate) {
    const startDate = new Date(filters.startDate);
    params[`${dateAttribute}[after]`] = formatDateAsQueryParam(startDate);
  }
  if (filters?.endDate) {
    const endDate = new Date(filters.endDate);
    const query = strictBefore ? 'strictly_before' : 'before';
    params[`${dateAttribute}[${query}]`] = formatDateAsQueryParam(addDaysToDate(endDate, 1));
  }
  if (filters?.material) {
    params['material'] = filters.material;
  }
  if (filters?.client) {
    params['client'] = filters.client;
  }
  if (filters?.stream) {
    params['stream'] = filters.stream;
  }
  if (filters?.buyer) {
    params['buyer'] = filters.buyer;
  }
  return params;
}
